import type { ReactElement } from 'react';

import { SegTabs } from '@/components/ui/SegTabs';

import { TABS, TABS_ID_PREFIX } from '../tabs';
import type { NotificationsTab } from '../use-url-state';

/** Pestañas de Notificaciones sobre el control segmentado compartido. */
export function NotificationsTabs({
  tab,
  onChange,
}: {
  tab: NotificationsTab;
  onChange: (t: NotificationsTab) => void;
}): ReactElement {
  return (
    <SegTabs
      tabs={TABS}
      value={tab}
      onChange={onChange}
      label="Secciones de notificaciones"
      idPrefix={TABS_ID_PREFIX}
    />
  );
}
